
import { Component, Mixins } from "vue-property-decorator";
import { CoachReportMixin, SportsSelectorMixin } from "@/mixins";
import { AthleteReportCategoryHeading, AthleteReportModelEx } from "@/models";
import { athleteReportApi } from "@/api/AthleteReportApi"
import ScoreSelector from '@/components/forms/ScoreSelector.vue';
import { notificationStore } from "@/store";

@Component({
	components: {
		ScoreSelector,
	}
})
export default class CoachAthleteReport extends Mixins(CoachReportMixin, SportsSelectorMixin) {
	athleteReport: AthleteReportModelEx;

	async createNewReport() {
		this.athleteReport = new AthleteReportModelEx(this.athleteId, this.teamId, this.coachId);
		await this.athleteReport.initialize();
	}
	async findReport() {
		const foundReport = await athleteReportApi.findById( this.reportId );
		this.athleteReport = new AthleteReportModelEx().load(foundReport);
		await this.athleteReport.loadAthleteCoach();
		await this.athleteReport.loadAthlete();
	}
	async updateReport() {
		await this.athleteReport.updateReport(this.athleteId, this.teamId, this.coachId);
	}
	async updateFromReport() {
		this.athleteId = this.athleteReport?.athleteId;
		this.teamId = this.athleteReport?.teamId;
		this.coachId = this.athleteReport?.coachId;		
	}

	// in process of loading some information from back-end
	get IsLoading(): boolean {
		return this.isReportLoading || this.isReportUpdating || this.isSportsLoading;
	}
	get DebugInfo() {
		return {a: this.AthleteName, c: this.CoachName, t: this.TeamName};
	}
	get IsAthleteLoaded(): boolean {
		if( !this.isReportLoaded ) return false;
		return this.athleteReport.HasAthleteProfile;
	}
	get AthleteName(): string {
		if( !this.isReportLoaded ) return this.athleteId;
		return this.athleteReport.AthleteName;
	}
	get CoachName(): string {
		if( !this.isReportLoaded ) return this.coachId;
		return this.athleteReport.CoachName;
	}
	get TeamName(): string {
		if( !this.isReportLoaded ) return this.teamId;
		return this.athleteReport.TeamName;
	}

	async onExpandHeading(heading: AthleteReportCategoryHeading) {
		heading.expanded = !heading.expanded;
		this.onReportChanged();
	}
	async onNewAthleteReport() {
		await this.gotoCoachAthleteReport();
		await this.resetAthleteLink();
		await this.initializeReport();
	}
	async onCancel() {
		if( this.isReportChanged ) {
			if( !confirm(`Are you sure you want to exit this form? Your changes will not be saved.`) ) return;
		}

		this.gotoCoachAthleteReportsSummary();
	}
	async onSave() {
		if( !this.isReportChanged ) return;

		this.isReportLoaded = false;
		this.athleteReport = new AthleteReportModelEx().load(this.athleteReport);
		this.isReportLoaded = true;
		if( this.IsEmpty(this.athleteReport.teamId) ) this.athleteReport.teamId = this.athleteReport.TeamName;
		this.athleteReport.tags = `${this.athleteReport.athlete.FullName}, ${this.athleteReport.TeamName}`;
		await athleteReportApi.save(this.athleteReport);

		notificationStore.pushSnackbarSuccess({message: 'Athlete Report saved successfully'});
		this.gotoCoachAthleteReportsSummary();
	}

	async onSubmitStart() {
		this.onSave();
	}
}
